import { CloseOutlined } from "@material-ui/icons";
import { useEffect, useState } from "react";
import OtpInput from "react-otp-input";
import { Col, Row } from "reactstrap";
import ImageChain from "../../../assets/ImageChain";
import ButtonCommon from "../../../components/ButtonCommon";
import CommonModal from "../../../components/CommonModal";
import InputCommon from "../../../components/InputCommon";
import './../index.scss'
import CustomAlerts from "../../../components/AlertCustom.js";
import { getOtpWithUsername, confirmOtpWithEntityId, sendOtpWithEntityId } from '../../../api/onboarding';

const ConfirmationModal = (props) => {

    const [OTP, setOTP]= useState("");
    const [username, setUsername] = useState('');
    const [modal, setModal] = useState(1);
    const [loading, setLoading] = useState(false);
    const [seconds, setSeconds ] = useState(60);
    let myInterval

    useEffect(() => {
      setModal(1)
      setUsername('')
    },[props.open])

    useEffect(()=>{
      myInterval = setInterval(() => {
        if (seconds > 0) {
          setSeconds(seconds - 1);
        }
        if (seconds === 0) {
          clearInterval(myInterval)
        } 
      }, 1000)
      return ()=> {
        clearInterval(myInterval);
      };
    });

    const submitUsername = () => {
      if (!username) {return}
      setLoading(true);
      getOtpWithUsername(props.currentEntity.taxableEntityId, username).then(res => {
        sendOtpWithEntityId(props.currentEntity.taxableEntityId).then(res => {
          //setUsername('');
          setSeconds(60);
          setModal(2);
          setLoading(false)
        }).catch(err => {
          setUsername('')
          setModal(3);
          setLoading(false)
        });
      })
    }

    const confirmOtp = () => {
      setLoading(true)
      confirmOtpWithEntityId(props.currentEntity.taxableEntityId, OTP).then(res => {
        setOTP('')
        setLoading(false)
        props.onConfirm();
      }).catch(err => {
        setLoading(false)
        setOTP('')
        CustomAlerts({
          message : err.message,
          title:'Error',
          type:'danger'
        })
      })
    }

    const viewDetail = () => {
      window.open('/Enable-API-access-on-GST-Portal.pdf', '_blank')
      props.setCloseModal();
    }

    const resentOTP =() => {
      setSeconds(60)
      submitUsername()
    }

    const changeUsername = () => {
      clearInterval(myInterval);
      setUsername('');
      setModal(1);
    }

    const renderModalData = () => {
        if (modal == 1) {
          return (
            <div className="confirmationModalInner">
              <div className="modalHeader">
                <ImageChain />
                Connect to GSTN
              </div>
              <p>Generate OTP for GSTIN: {props.currentEntity.provisionalGstin} ({props.currentEntity.state})</p>
              <Col md={12}>
                <label>GSTN User Name</label>
                <InputCommon value={username} onChange={(e) => setUsername(e.target.value)} />
              </Col>
              <ButtonCommon disabled={loading} onClick={() => submitUsername()} title="Get OTP" />
            </div>
          )
        } if (modal == 2) {
            return (<div className="confirmationModalInner">
                <div className="modalHeader">
                  <ImageChain />
                  Connect to GSTN
                </div>
                <p>Generate OTP for GSTIN: {props.currentEntity.provisionalGstin} ({props.currentEntity.state})</p>
                <Col md={12}>
                    <label>Enter OTP received on your GSTN registered mobile number</label>
                    <OtpInput
                      value={OTP}
                      onChange={(val) => setOTP(val)}
                      numInputs={6}
                      containerStyle="OTPCon"
                      inputStyle="OTPInput"
                    />
                    <div className="linksCon">
                      <p>
                        <span className="userNameSpan">Username: {username}</span>
                        <span className="cursorPointer" onClick={() => changeUsername()}>
                          Change Username 
                        </span>
                        {seconds == 0 && 
                          <span className="cursorPointer" onClick={() => resentOTP()}>
                             {' '} / {' '} Resend OTP
                          </span>
                        }
                      </p>
                    </div>
                </Col>
                <Row>
                <Col md={6}>
                  <ButtonCommon disabled={loading} onClick={() => confirmOtp()} title="Verify and proceed" />
                </Col>
                <Col md={6}>
                  {seconds !== 0 &&
                    <p style={{float: 'right', margin: 0, marginTop: 40}}>
                      Resend OTP in 00:{seconds < 10 ? '0' :''}{seconds}
                    </p>
                  }
                </Col>
                </Row>
            </div>)
        } else {
            return (<div className="confirmationModalInner">
                <div className="modalHeader">
                  <ImageChain />
                  Connect to GSTN
                </div>
                <p>To receive OTP, please follow the below guide to activate API access on the government portal. </p>
                <p> Login to GSTN > Go to your GSTN profile > Manage API Access > Select Yes > Confirm - to continue with your task</p>
                <Col md={10}>
                    
                </Col>
                <ButtonCommon onClick={() => viewDetail()} title="View detailed guide" className="reverted" />
            </div>)
        }
    }


    return (
      <CommonModal className="confirmationModal" open={props.open}>
        <div onClick={() => props.setCloseModal()} className="modalCloseBtn">
          <CloseOutlined />
        </div>
        {renderModalData()}
      </CommonModal>
    )
}

export default ConfirmationModal;